import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface analysisImageIdI {
  workId: string
  imageId: string
  selectedPage: number
  selectedComparison: number
}

const initialState: analysisImageIdI = {
  workId: '',
  imageId: '',
  selectedPage: 0,
  selectedComparison: 0
}

export const setAnalysisImageInfoISlice = createSlice({
  name: 'setAnalysisImageInfo',
  initialState,
  reducers: {
    setAnalysisWorkId: (state, action: PayloadAction<string>) => {
      state.workId = action.payload
    },
    setAnalysisImageId: (state, action: PayloadAction<string>) => {
      state.imageId = action.payload
    },
    setSelectedPage: (state, action: PayloadAction<number>) => {
      state.selectedPage = action.payload
    },
    setSelectedComparison: (state, action: PayloadAction<number>) => {
      state.selectedComparison = action.payload
    }
  }
})
export const { setAnalysisWorkId, setAnalysisImageId, setSelectedPage, setSelectedComparison } =
  setAnalysisImageInfoISlice.actions
export default setAnalysisImageInfoISlice.reducer
